import FeedbackMessageWrapper from 'components/Form/FieldFeedback/FieldFeedback.style';
import styled, { css } from 'styled-components';
import { Input } from './Input';
import { LabelInput } from './LabelInput';
import { FieldUIStates } from 'components/Form/Form.config';
import { getThemeColor } from 'style-utils/theme/utils/getThemeColor';

export interface FormGroupProps {
  fieldState?: FieldUIStates;
}

export const FormGroup = styled.div<FormGroupProps>`
  flex: 1;
  position: relative;
  ${({ fieldState }) => {
    if (fieldState === FieldUIStates.alert) {
      return isAlertState;
    }
    if (fieldState === FieldUIStates.error) {
      return isErrorState;
    }

    return `color: ${getThemeColor('textPrimary')}`;
  }};
`;

export const isAlertState = css`
  color: ${getThemeColor('alertFieldColor')};
  & > ${LabelInput}, & + ${FeedbackMessageWrapper} {
    color: ${getThemeColor('alertFieldColor')} !important;
  }

  & > ${Input}, & > ${Input}:focus {
    border-color: ${getThemeColor('alertFieldColor')};
  }
`;

export const isErrorState = css`
  color: ${getThemeColor('errorFieldColor')};

  & > ${LabelInput}, & + ${FeedbackMessageWrapper} {
    color: ${getThemeColor('errorFieldColor')} !important;
  }

  & > ${Input}, & > ${Input}:focus {
    border-color: ${getThemeColor('errorFieldColor')};
  }
`;
